import styled from 'styled-components';
import { Button } from '../../Button/Button';

export const SubmitButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
`;
